<template>
  <div>
    <meta name="viewport" content="width=device-width, user-scalable=no, minimum-scale=1.0, maximum-scale=1.0">
    <div id="video-container" class="d-flex justify-content-center align-items-center">
      <div id="viewport" class=""">
        <video ref="localVideo" id="local-video" style="display:none;" autoplay webkit-playsinline="true" playsinline="true"></video>
        <video ref="remoteVideo" id="remote-video" style="display:none;" autoplay webkit-playsinline="true" playsinline="true"></video>
        <canvas ref="canvas" id="canvas"></canvas>
        <div  id="controls" class="p-3">
          <div>
            <button id="snap" v-on:click="closeCamera()" class="btn btn-danger rounded-circle btn-sm">
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
          <div>
          </div>
          <div>
            <div class="dropdown dropup" id="switchCamera" v-if="devices.length > 1">
              <a class="btn btn-secondary dropdown-toggle rounded-circle btn-sm" href="javascript:void(0)" @click="toggleDropdown">
                <i class="fa fa-retweet" aria-hidden="true"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-right">
                <a v-for="device in devices" class="dropdown-item" href="javascript:void(0)" v-on:click="changeCamera(device.deviceId)">{{device.label}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <canvas ref="photo" id="photo" class="hidden"></canvas>
  </div>
</template>

<script>

import moment from 'moment';

const { RTCPeerConnection, RTCSessionDescription } = window;

export default {
  name: 'Video',
  data: () => ({
    video: null,
    remoteVideo: null,
    canvas: null,
    devices: [],
    device: {
      id: null
    },
    messages:[],
    peerConnection: ''
  }),
  props: ['guest', 'camera', 'changeDOB'],
  mounted(){
    document.querySelector('body').style="overflow:hidden;";
    this.video = this.$refs.localVideo;
    this.remoteVideo = this.$refs.remoteVideo;
    this.canvas = this.$refs.canvas;

    if (!('createImageBitmap' in window)) {
      window.createImageBitmap = async function(blob) {
        return new Promise((resolve,reject) => {
          let img = document.createElement('img');
          img.addEventListener('load', function() {
              resolve(this);
          });
          img.src = URL.createObjectURL(blob);
        });
      }
    }

    if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.enumerateDevices()
      .then(devices => {
        if(devices.find(d => d.kind == 'videoinput' && d.label.indexOf("back") >= 0)){
          return devices.filter(d => d.kind == 'videoinput' && d.label.indexOf("back") >= 0)
        }
        return devices.filter(d => d.kind == 'videoinput');
      })
      .then(devices => {
        console.log(devices)
        this.devices = devices;
        if(this.devices.length){
          console.log(this.devices);
          this.device.id = this.devices[0].deviceId;
          let constraints = {video: { deviceId: this.device.id,  width: { exact: 1280}, height: {exact: 720}, frameRate: { max: 10 } } };
          this.video.width = 1280;
          this.video.height = 720;
          window.addEventListener('resize', this.resize);

          return this.init(constraints);
        }
      })
      .then(() => {
        this.localPeerConnection = new RTCPeerConnection({
          sdpSemantics: 'unified-plan',
          iceServers: [{urls: ['stun:stun.l.google.com:19302']}]
        });

        let pc = this.localPeerConnection;

        this.localPeerConnection.addEventListener('icegatheringstatechange', function() {
          console.log("gathering state");
          console.log(pc.iceGatheringState);
        }, false);

        this.localPeerConnection.addEventListener('iceconnectionstatechange', function() {
          console.log("connection state");
          console.log(pc.iceConnectionState);
        }, false);

        this.localPeerConnection.addEventListener('signalingstatechange', function() {
          console.log("signaling state");
          console.log(pc.signalingState);
        }, false);

        // connect audio / video
        this.localPeerConnection.addEventListener('track', function(evt) {
          if (evt.track.kind == 'video'){
            console.log("dodajamo vide tralalal ----- hopsapsa")
            document.getElementById('remote-video').srcObject = evt.streams[0];
          }
        });

        /*this.localPeerConnection.addEventListener('datachannel', function(evt) {
          console.log("--------------------------")
          console.log("datachannel")
          let dc = evt.channel
          console.log(dc)
          dc.addEventListener('close', () => {
            console.log("--------------------------")
            console.log("closed")
            console.log(dc);
          });

          dc.addEventListener('open', () => {
            console.log("--------------------------")
            console.log("opened")
            console.log(dc)
          });

          dc.addEventListener('message', (evt) => {
            console.log("--------------------------")
            console.log("message")
            console.log(evt.data);
            if (evt.data.substring(0, 4) === 'pong') {
                var elapsed_ms = Date.now() - parseInt(evt.data.substring(5), 10);
            }
          });
        });*/

        return this.video.srcObject.getTracks().forEach(track => this.localPeerConnection.addTrack(track, this.video.srcObject))
      })
      .then(() => {
        let dc = this.localPeerConnection.createDataChannel('guest', {negotiated: true, id: 0})
        let dcInterval;
        dc.addEventListener('close', () => {
          console.log("closed");
          clearInterval(dcInterval);
        });

        dc.addEventListener('open', () => {
          console.log("opened");
          console.log("ping")
          dc.send("ping");
        });

        dc.addEventListener('message', (evt) => {
          console.log(evt.data);
          let data = JSON.parse(evt.data);
          this.guest.name.last = data[0];
          this.guest.name.first = data[1];
          this.guest.country = data[3];
          this.guest.dob.year = Number(data[4].substring(0,2)) ? moment(Number(data[4].substring(0,2)), "YY").format("YYYY") : null;
          this.guest.dob.month = Number(data[4].substring(2,4));
          this.guest.dob.day = Number(data[4].substring(4,6));
          this.guest.gender = data[6];
          this.guest.document.type = data[7].replace("1", "I").substring(0,1);
          this.guest.document.number = data[8];

          //izračunaj turistično takso
          this.changeDOB();

          console.log(this.guest);
          this.closeCamera();
        });
      })
      .then(() => this.localPeerConnection.createOffer())
      .then(offer => {
        let sessionDescription = new RTCSessionDescription({
          type: 'offer',
          sdp: offer.sdp
        });
        return this.localPeerConnection.setLocalDescription(sessionDescription);
      })
      .then(() => {
        let pc = this.localPeerConnection;
        return new Promise(function(resolve) {
          if (pc.iceGatheringState === 'complete') {
            resolve();
          } else {
            function checkState() {
              if (pc.iceGatheringState === 'complete') {
                pc.removeEventListener('icegatheringstatechange', checkState);
                resolve();
              }
            }
            pc.addEventListener('icegatheringstatechange', checkState);
          }
        });
      })
      .then(() => {
        return fetch(process.env.VUE_APP_API + '/webrtc/offer', {
          method: 'post',
          credentials: 'include',
          headers: {
            "Content-type": "application/json",
            "Accept": "application/json",
            "Accept-Charset": "utf-8",
            'CSRF-Token': this.$csrf
          },
          body: JSON.stringify({
            sdp: this.localPeerConnection.localDescription.sdp,
            type: this.localPeerConnection.localDescription.type,
            video_transform: "none"
          })
        })
      })
      .then(response => response.json())
      .then(response => {
        console.log("tole je response")
        console.log(response.type);
        console.log(response.sdp);

        let sessionDescription = new RTCSessionDescription({
          type: response.type,
          sdp: response.sdp
        });

        return this.localPeerConnection.setRemoteDescription(sessionDescription);
      })
      .then(() => {
        /*console.log(this.localPeerConnection.getReceivers());
        const remoteStream = new MediaStream(this.localPeerConnection.getReceivers().map(receiver => receiver.track));

        console.log(remoteStream)
        this.remoteVideo.srcObject = remoteStream;*/
        console.log("končni response");
        this.play();
      })
    }

  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
    document.querySelector('head meta[name="viewport"]').setAttribute('content', 'width=device-width,initial-scale=1');
    window.removeEventListener('resize', this.resize);
    let senderList = this.localPeerConnection.getSenders();
    senderList.forEach(sender => {
      this.localPeerConnection.removeTrack(sender)
    })
    this.localPeerConnection.close();
    this.video.srcObject.getTracks().forEach(t => t.stop());
  },
  methods: {
    error(err) {
      console.warn('Error', err);
    },
    init(constraints){
      console.log("initiating")
      return navigator.mediaDevices.getUserMedia(constraints).then(stream => {
        this.video.srcObject = stream;
        const track = stream.getVideoTracks()[0];
        this.video.play();
        this.resize();
      })
    },
    toggleDropdown: function(e){
      const link = e.target;
      const menu = link.nextSibling;

      menu.classList.toggle("show");
      return;
    },
    closeDropdown: function(e){
      const dropdown = document.querySelector('#switchCamera');
      if(dropdown && !dropdown.querySelector("a").contains(e.target)){
        dropdown.querySelector("a").contains(e.target) || dropdown.querySelector('.dropdown-menu').classList.remove("show");
      }
    },
    closeCamera(){
      this.video.pause();
      this.camera.show = false;
    },
    changeCamera(deviceId) {
      this.video.srcObject.getTracks().forEach(t => t.stop());
      this.init({video: {deviceId: { exact: deviceId}, width: { exact: 1280}, height: {exact: 720}, frameRate: { max: 10 } }});
    },
    draw(canvas, image, filter = null) {
      let context = canvas.getContext("2d");
      let scale = Math.max(canvas.height / image.height, canvas.width / image.width)
      let x = (canvas.width / 2) - (image.width / 2) * scale;
      let y = (canvas.height / 2) - (image.height / 2) * scale;
      context.filter = filter;
      context.drawImage(image, x, y, image.width * scale, image.height * scale);
    },
    drawRectangle(canvas, color){
      let c = canvas.getContext('2d');
      let w = canvas.width;
      let h = canvas.height;
      c.strokeStyle = color;
      c.lineWidth = 5;
      if(w > h){
        if(w / h <= 3 / 2){
          c.strokeRect(20, (h - (w-40) / 3 * 2) / 2, w-40, (w-40) / 3 * 2);
        }else{
          c.strokeRect((w - (h-40) * 3 / 2) / 2, 20, (h-40) * 3 / 2, h-40);
        }
      }else{
        if(h / w <= 3 / 2){
          c.strokeRect( (w - (h-40) / 3 * 2) / 2, 20, (h-40) / 3 * 2, h-40);
        }else{
          c.strokeRect(20, (h - (w-40) * 3 / 2) / 2, w-40, (w-40) * 3 / 2);
        }
      }
    },
    writeText(canvas, text, font, color, x, y, align="left"){
      let c = canvas.getContext('2d');
      c.textAlign = align;
      c.fillStyle = color;
      c.font = font;
      c.fillText(text, x, y);
    },
    play(){
      let c = this.canvas.getContext('2d');
      c.save();
      let v = this.remoteVideo;
      //if(v.paused || v.ended) return false;

      let w = this.canvas.width;
      let h = this.canvas.height;

      this.draw(this.canvas, v)
      this.drawRectangle(this.canvas, "#00FF00");

      if(w > h){
        this.writeText(this.canvas, "Osebno izkaznico v okvir", "15px Arial", "#00FF00", w/2, h/2, "center");
      }else{
        c.rotate(Math.PI / 2);
        this.writeText(this.canvas, "Osebno izkaznico v okvir", "15px Arial", "#00FF00", h/2, -w/2, "center");
      }

      if(this.messages.length){
        let line = 50;
        this.messages.forEach(message => {
          if(w > h){
            this.writeText(this.canvas, message, "16px Arial", "#FF0000", 60, line)
          }else{
            this.writeText(this.canvas, message, "16px Arial", "#FF0000", 60, -(w - line))
          }
          line += 20;
        })
      }
      c.restore();

      setTimeout(this.play,20);
    },
    resize(){
      let container = document.getElementById("video-container");
      let controls = document.getElementById("controls");

      if(container.clientHeight < container.clientWidth){
        this.video.width = 1280;
        this.video.height = 720;

        this.remoteVideo.width = 1280;
        this.remoteVideo.height = 720;

        this.canvas.width = container.clientWidth - controls.clientWidth <= this.video.width ? container.clientWidth - controls.clientWidth : this.video.width;
        this.canvas.height = container.clientHeight <= this.video.height ? container.clientHeight : this.video.height;
      }else{
        this.video.width = 720;
        this.video.height = 1280;

        this.remoteVideo.width = 720;
        this.remoteVideo.height = 1280;

        this.canvas.width = container.clientWidth <= this.video.width ? container.clientWidth : this.video.width;
        this.canvas.height = container.clientHeight - controls.clientHeight <= this.video.height ? container.clientHeight - controls.clientHeight : this.video.height;
      }
    }
  }
}
</script>

<style>
#video-container{
  top:0;
  left:0;
  position:fixed;
  height:100%;
  width:100%;
  z-index:10000;
  display:block;
  background-color:#696969;
  overflow: hidden;
}

#viewport{
  display: flex;
  flex-direction: row;
  box-shadow: 0px 0px 0px 2px #000000;
  background-color:#221F1F
}

#controls{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

@media only screen and (orientation: portrait) {
  #viewport{
    flex-direction: column;
  }
  #controls{
    flex-direction: row-reverse

  }
  #controls button{
    transform: rotate(90deg);
  }
  .dropdown.dropup{
    transform: rotate(90deg);
  }
}
</style>
